export type ApiReadResponse<T> = {
  records: T[]
  total_count: number
}
